<template>
  <div class="d-flex flex-column gap-8">
    <div class="d-flex align-center justify-space-between gap-8">
      <v-spacer />
      <SearchFilterVerifiedOnly />
      <SearchFilterWorkspaceOnly />
    </div>
    <template v-if="items.length">
      <div
        v-for="item in items"
        :key="item.title"
        :data-test="`${item.dataTest}_section`">
        <GroupItems
          :is-show-action-icon="isShowActionIcon"
          :item="item"
          v-on="$listeners" />
      </div>
    </template>
    <template v-else>
      <div class="d-flex flex-column align-center text-center gap-4 fs-24 pt-16">
        <span>Sorry, I could not find anything that matches your search.</span>
        <span>Please try a new query.</span>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'CollectionsSearchGroups',
  components: {
    GroupItems: () => import('./CollectionsSearchGroupItems'),
    SearchFilterWorkspaceOnly: () => import('@/components/SearchFilter/SearchFilterWorkspaceOnly'),
    SearchFilterVerifiedOnly: () => import('@/components/SearchFilter/SearchFilterVerifiedOnly'),
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isShowActionIcon: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
